import { openModal } from '@core/components/ModalStack';
import { AddProductOverlayProps } from './AddProductOverlay';

export async function openAddProductOverlay(props: AddProductOverlayProps) {
  const { AddProductOverlay } = await import('./AddProductOverlay');

  openModal(AddProductOverlay, props);
}
